<template>
  <div class="col-12">
    <div v-for="report in reports" :key="report._id" style="margin-top: 0.5em;">
      <div v-if="report.trainingTracker && report.trainingTracker.daysTracker && report.trainingTracker.daysTracker.length > 0">
        <div v-for="dayReport in report.trainingTracker.daysTracker" :key="dayReport._id">
          <div class="report-card">
            <card class="rounded" @click.native="viewReport(dayReport, report)">
              <div class="col-2" style="padding: 0px;display: flex;align-items: center;">
                <i class="el-icon-tickets" style="font-size: 2.5em;"></i>
              </div>
              <div class="col-10" style="padding: 0px;">
                <div class="col-12" style="padding: 0px;font-size: 1.1em">
                  {{ `${report.trainingTracker.training.title} - Day ${dayReport.day}` }}
                </div>
                <div class="col-12" style="padding: 0px;margin-top: 0.3em;font-size: 0.9em;">
                  <div style="display: inline;margin-right: 0.5em;" v-if="getDuration(dayReport)">
                    <i class="fas fa-stopwatch" style="font-size: 1.1em;"></i> {{ getDuration(dayReport) }}
                  </div>
                  <div style="display: inline;">
                    <i class="fas fa-clock"></i> {{ getFormattedDate(dayReport.exerciseTracker[dayReport.exerciseTracker.length - 1].statusHistory[dayReport.exerciseTracker[dayReport.exerciseTracker.length - 1].statusHistory.length - 1].timestamp) }}
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!reports || reports.length == 0" class="col-12 text-center">
      <i class="fa fa-info-circle"></i>
      No reports available
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reports: [],
    };
  },

  async mounted() {
    try {
      let trackerFunction = "getFitnessTrackers";
      if (this.$store.state.trainingType == "yoga") {
        trackerFunction = "getYogaTrackers";
      }
      this.reports = await this.$store.dispatch(trackerFunction, this.user._id);
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    getDuration(dayReport) {
      let duration = null;
      let lastExercise =
        dayReport.exerciseTracker[dayReport.exerciseTracker.length - 1];
      if (lastExercise && lastExercise.latestStatus != "COMPLETED") {
        return duration;
      }
      for (let exercise of dayReport.exerciseTracker) {
        if (exercise.latestStatus == "COMPLETED") {
          let startTime = exercise.statusHistory[0].timestamp;
          let endTime =
            exercise.statusHistory[exercise.statusHistory.length - 1].timestamp;
          let seconds = Math.floor((endTime - startTime) / 1000);
          let minutes = Math.floor(seconds / 60);
          let hours = Math.floor(minutes / 60);

          if (!duration) {
            duration = {
              hours: 0,
              minutes: 0,
              seconds: 0,
            };
          }

          duration = {
            hours: duration.hours + hours,
            minutes: duration.minutes + minutes,
            seconds: duration.seconds + seconds,
          };
        }
      }

      if (duration) {
        let days = Math.floor(duration.hours / 24);
        duration.hours = duration.hours - days * 24;
        duration.minutes =
          duration.minutes - days * 24 * 60 - duration.hours * 60;
        duration.seconds =
          duration.seconds -
          days * 24 * 60 * 60 -
          duration.hours * 60 * 60 -
          duration.minutes * 60;

        duration = `${("0" + duration.hours).slice(-2)}:${(
          "0" + duration.minutes
        ).slice(-2)}:${("0" + duration.seconds).slice(-2)}`;
      }

      return duration;
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    viewReport(dayReport, report) {
      this.$store.commit("setState", {
        stateName: "fitnessOrYogaReport",
        stateValue: {
          ...dayReport,
          training: report.trainingTracker.training,
        },
      });
      this.$router.push("viewfitnessandyogareports");
    },
  },
};
</script>

<style scoped>
/deep/ .report-card .card-body {
  display: flex;
  align-items: center;
  padding: 15px;
}
</style>
